import React from 'react';
import { LeaseExtensionCalculator as LeaseExtensionCalculatorComponent } from '../../calculators/LeaseExtensionCalculator';
import { Section } from '../../Section';

export const LeaseExtensionCalculator = ({ ...rest }) => (
  <Section contained narrow {...rest}>
    <LeaseExtensionCalculatorComponent
      {...rest}
      introCopy="Use our quick and easy lease extension calculator to estimate how much it will cost to extend your lease."
    />
  </Section>
);
